const model = {
    arrayMenu: null,
    error: null,
    loading: false
};
    
export default model;